import styled from "styled-components";
import Hr from ".";

export default styled(Hr)`
	margin: 0;
`